export default {"src":"/ai/_next/static/media/assistant_logo.89aa3cd7.svg","height":41,"width":174,"blurWidth":0,"blurHeight":0};